<ng-container
  *ngIf="{
    article: article$ | async,
    showArticleError: showArticleError$ | async,
    isSimilarArticlesExpanded: isSimilarArticlesExpanded$ | async,
  } as data"
>
  <tr *ngIf="data.isSimilarArticlesExpanded">
    <td colspan="5" class="pt-0">
      <ng-template
        [ngTemplateOutlet]="similarArticlesTemplate"
        [ngTemplateOutletContext]="{
          carouselData: {
            showTitle: true,
            showAlternativeArticleBadge: true,
            showPaginationAtTheBottom: true,
            useDefaultArticleQuantityAndUnit: true,
          },
        }"
      ></ng-template>
    </td>
  </tr>
</ng-container>
